'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _RouteCollection = require('./RouteCollection');

var _RouteCollection2 = _interopRequireDefault(_RouteCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Switch React component
 * Use in place of Switch from `react-router-dom` to extract names and paths from child routes
 * @param {object} routeSwitch provided by react
 * @public
 *
 * @return {React.Component}
 */
var Switch = function Switch(routeSwitch) {
  var childRoutes = routeSwitch.children;

  if (!Array.isArray(childRoutes) && childRoutes !== undefined) {
    childRoutes = [childRoutes];
  }

  childRoutes.reduce(function (result, route) {
    if (Array.isArray(route)) {
      result.push.apply(result, (0, _toConsumableArray3.default)(route));
    } else {
      result.push(route);
    }

    return result;
  }, []).filter(function (route) {
    return route.props;
  }).forEach(function (route) {
    return _RouteCollection2.default.addRoute(route.props.name, route.props);
  });

  return _react2.default.createElement(_reactRouterDom.Switch, routeSwitch);
};

exports.default = Switch;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-named-routes/build/Switch.js
// module id = 950
// module chunks = 0